import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';

const categoryCards = categories.filter((c) => c.slug !== 'all');

export default function CategorySection() {
  return (
    <section className="bg-background-100 py-12 md:py-16" id="categories">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <h2 className="flex items-center gap-2 font-display text-2xl md:text-3xl">
            <span className="text-accent-500">
              <i className="ri-grid-fill text-2xl md:text-3xl" aria-hidden="true" />
            </span>
            热门漫画分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            全部漫画
            <i className="ri-arrow-right-line ml-1" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categoryCards.map((c) => {
            const count = comics.filter((comic) => comic.category === c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group rounded-lg bg-background-50 p-5 hover-lift"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-2xl`} aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-display text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {c.name}
                </h3>
                <p className="mt-1.5 text-xs leading-5 text-foreground-600 line-clamp-2">{c.description}</p>
                <div className="mt-3 flex items-center justify-between text-xs">
                  <span className="inline-flex items-center gap-1 text-foreground-600">
                    <i className="ri-book-2-line" aria-hidden="true" />
                    {count}部作品
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                    去看看
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}